const API_BASE = process.env.REACT_APP_API_HOST;

export const PAGE_NAMES = {
  '/admin/dashboard': 'Dashboard',
  '/admin/metric': 'Metric',
  '/admin/users': 'Users list page',
  '/admin/markets': 'Markets list page',
  '/admin/matches': 'Matches list page',
  '/admin/operators': 'Operators list page',
  '/admin/bets': 'Bets list page',
  '/admin/betsHistory': 'Bets History page',
  '/admin/betsInsights': 'Bet Insights page',
  '/admin/changePassword': 'Change Password page',
  '/admin/results': 'Results page',
  '/admin/fortest': 'For Test page',
  '/operator/dashboard': 'Dashboard',
  '/operator/markets': 'Markets list page',
  '/operator/matches': 'Matches list page',
  '/operator/operators': 'Operators list page',
  '/operator/bets': 'Bets list page',
  '/operator/betsHistory': 'Bets History page',
  '/operator/betsInsights': 'Bet Insights page',
  '/operator/changePassword': 'Change Password page',
  '/operator/results': 'Results page',
  '/user/home': 'Home page',
  '/login': 'Login page',
  '/register': 'Register page',
};

const LIST_PAGES = new Set([
  '/admin/users',
  '/admin/markets',
  '/admin/matches',
  '/admin/operators',
  '/admin/bets',
  '/admin/betsHistory',
  '/admin/betsInsights',
  '/admin/results',
  '/operator/markets',
  '/operator/matches',
  '/operator/operators',
  '/operator/bets',
  '/operator/betsHistory',
  '/operator/betsInsights',
  '/operator/results',
]);

const SKIP_LOG_PAGES = new Set(['/admin/activityLogs', '/admin/dashboard', '/operator/dashboard']);

const ALLOWED_ACTIONS = new Set([
  'login',
  'logout',
  'view',
  'list',
  'create',
  'edit',
  'delete',
  'update',
]);

const formatName = (str) => {
  const value = (str || '').trim();
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const getDisplayName = () => {
  const name = localStorage.getItem('name');
  const username = localStorage.getItem('username');
  return formatName(name || username);
};

export const isLoggedIn = () =>
  Boolean(localStorage.getItem('username') || localStorage.getItem('jwt'));

export const shouldSkipPageLogging = (pathname) => SKIP_LOG_PAGES.has(pathname);

export const getPageAction = (pathname) => {
  if (LIST_PAGES.has(pathname)) return 'list';
  if (pathname.startsWith('/admin/jodi-report') || pathname.startsWith('/operator/jodi-report')) {
    return 'list';
  }
  return 'view';
};

const buildDescription = (action, target, displayName) => {
  const name = displayName || 'User';

  switch (action) {
    case 'login':
      return `${name} logged in`;
    case 'logout':
      return `${name} logged out`;
    case 'view':
    case 'list':
      return `${name} viewed ${target}`;
    case 'create':
      return `${name} created ${target}`;
    case 'edit':
      return `${name} edited ${target}`;
    case 'update':
      return `${name} updated ${target}`;
    case 'delete':
      return `${name} deleted ${target}`;
    default:
      return `${name} ${action}${target ? ` ${target}` : ''}`;
  }
};

export const logActivity = async ({
  action,
  description,
  target,
  page_url,
  metadata,
} = {}) => {
  if (!ALLOWED_ACTIONS.has(action)) return;

  const displayName = getDisplayName();
  const username = localStorage.getItem('username');
  const user_id = localStorage.getItem('uid');
  const token = localStorage.getItem('jwt');
  const pageUrl = page_url || window.location.pathname;

  const payload = {
    user_id: user_id ? parseInt(user_id, 10) : null,
    username,
    user_name: displayName || null,
    action,
    description:
      description ||
      buildDescription(action, target || PAGE_NAMES[pageUrl] || pageUrl, displayName),
    page_url: pageUrl,
    metadata,
  };

  try {
    await fetch(`${API_BASE}/activity-log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // fire-and-forget
  }
};

export const logLogout = async () => {
  const displayName = getDisplayName();
  const username = localStorage.getItem('username');
  const user_id = localStorage.getItem('uid');
  const token = localStorage.getItem('jwt');

  const payload = {
    user_id: user_id ? parseInt(user_id, 10) : null,
    username,
    user_name: displayName || null,
    action: 'logout',
    description: `${displayName || formatName(username) || 'User'} logged out`,
    page_url: window.location.pathname,
  };

  try {
    await fetch(`${API_BASE}/activity-log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // fire-and-forget
  }
};

export const resolvePageName = (pathname) => {
  if (PAGE_NAMES[pathname]) return PAGE_NAMES[pathname];

  if (pathname.startsWith('/admin/jodi-report')) return 'Jodi Report page';
  if (pathname.startsWith('/operator/jodi-report')) return 'Jodi Report page';
  if (pathname.startsWith('/game-detail')) return 'Game Detail page';

  return pathname;
};
